export const DPG_DEAL_PLAN_ID = 'Basis_3M4EuroDiscount_Evergreen';
